// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .p-datatable .p-datatable-header {
    color: black;
    background: #f5f5f5;
    padding: 0;
    border: none;
}

::ng-deep .p-datatable-thead > tr > th {
    background-color: silver !important;
    font-size: 12px;
    padding: 0.5rem 0.75rem !important;
}

::ng-deep .p-datatable-thead .p-icon-wrapper {
    display: inline-block !important;
    vertical-align: middle;
}

::ng-deep .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(even) {
    background: #f4f4f4;
}

#results-table td {
    font-weight: normal;
    font-size: 11px;
    vertical-align: top;
}

.negativeField {
    color: red;
}

span.link {
    color: blue;
    cursor: pointer;
}

span.forTitles {
    font-style: italic;
    font-size: 150%;
}

tr.groupSummary, tr.groupSummary2, tr.groupSummary3, tr.groupSummary4 {
    box-shadow: inset -1px -1px 0px 0px rgba(0,0,0,0.25);
}

tr.groupSummary {
    background: linear-gradient(90deg, #b6d0e2, #E8FFFF) !important;
}

tr.groupSummary2 {
    background: linear-gradient(90deg, #e8e8e8, #FFFFFF) !important;
}

tr.groupSummary3 {
    background: linear-gradient(90deg, #e9c462, #FFF694) !important;
}

tr.groupSummary4 {
    background: linear-gradient(90deg, #033663, #356895) !important;
}

tr.groupSummary td,
tr.groupSummary span,
tr.groupSummary2 td,
tr.groupSummary2 span,
tr.groupSummary3 td,
tr.groupSummary3 span,
tr.groupSummary4 td,
tr.groupSummary4 span {
    font-weight: bolder;
}

tr.groupSummary4 td,
tr.groupSummary4 span {
    color: white;
}

.content-wrap {
    word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/app/reports/report-results/report-results.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,+DAA+D;AACnE;;AAEA;IACI,+DAA+D;AACnE;;AAEA;;;;;;;;IAQI,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":["::ng-deep .p-datatable .p-datatable-header {\r\n    color: black;\r\n    background: #f5f5f5;\r\n    padding: 0;\r\n    border: none;\r\n}\r\n\r\n::ng-deep .p-datatable-thead > tr > th {\r\n    background-color: silver !important;\r\n    font-size: 12px;\r\n    padding: 0.5rem 0.75rem !important;\r\n}\r\n\r\n::ng-deep .p-datatable-thead .p-icon-wrapper {\r\n    display: inline-block !important;\r\n    vertical-align: middle;\r\n}\r\n\r\n::ng-deep .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(even) {\r\n    background: #f4f4f4;\r\n}\r\n\r\n#results-table td {\r\n    font-weight: normal;\r\n    font-size: 11px;\r\n    vertical-align: top;\r\n}\r\n\r\n.negativeField {\r\n    color: red;\r\n}\r\n\r\nspan.link {\r\n    color: blue;\r\n    cursor: pointer;\r\n}\r\n\r\nspan.forTitles {\r\n    font-style: italic;\r\n    font-size: 150%;\r\n}\r\n\r\ntr.groupSummary, tr.groupSummary2, tr.groupSummary3, tr.groupSummary4 {\r\n    box-shadow: inset -1px -1px 0px 0px rgba(0,0,0,0.25);\r\n}\r\n\r\ntr.groupSummary {\r\n    background: linear-gradient(90deg, #b6d0e2, #E8FFFF) !important;\r\n}\r\n\r\ntr.groupSummary2 {\r\n    background: linear-gradient(90deg, #e8e8e8, #FFFFFF) !important;\r\n}\r\n\r\ntr.groupSummary3 {\r\n    background: linear-gradient(90deg, #e9c462, #FFF694) !important;\r\n}\r\n\r\ntr.groupSummary4 {\r\n    background: linear-gradient(90deg, #033663, #356895) !important;\r\n}\r\n\r\ntr.groupSummary td,\r\ntr.groupSummary span,\r\ntr.groupSummary2 td,\r\ntr.groupSummary2 span,\r\ntr.groupSummary3 td,\r\ntr.groupSummary3 span,\r\ntr.groupSummary4 td,\r\ntr.groupSummary4 span {\r\n    font-weight: bolder;\r\n}\r\n\r\ntr.groupSummary4 td,\r\ntr.groupSummary4 span {\r\n    color: white;\r\n}\r\n\r\n.content-wrap {\r\n    word-wrap: break-word;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
